<template>
  <div class="page">
    <!-- <div class="txt1">{{questionCount ? `ကျေးဇူးပြု၍ မေးခွန်း ${questionCount} ခု ဆက်လက် ဖြေဆိုပါ။` : 'Please challenge more' }}</div> -->
    <div class="btn-list">
        <img src="~@/assets/startnow.png" @click="_startNow" alt="">
        <!-- <img src="~@/assets/getmore.png" @click="_getMore" alt=""> -->
    </div>
    <van-list class="qs-list" v-model="loading" :finished="finished" finished-text="" @load="fetchList">
        <table class="qs-table">
            <thead>
                <tr>
                    <th>အဆင့်</th><th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in list" :key="index">
                    <td class="rank-icon">{{item.code}}</td>
                    <td class="status-btn">
                      <img v-if="item.status==='0'" src="~@/assets/status-0.png" @click="gotoReview(item)" alt="">
                      <img v-if="item.status==='1'"  src="~@/assets/status-1.png" @click="gotoAnswer(item)" alt="">
                      <img v-if="item.status==='2'" src="~@/assets/status-2.png" @click="gotoAnswer(item)" alt="">
                    </td>
                </tr>
            </tbody>
        </table>
    </van-list>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import config from "../config";
import { get } from "lodash";

export default {
  name: "Myqs",
  data() {
    return {
        loading: false,
        finished: false,
        questionCount: 0,
        list: [],
        page: 1
    };
  },
  computed: {
    ...mapState(["lang"]),
    showGetBtn(){
        return this.list.some(item=>item.status!=0);
    }
  },
  created() {
  },
  methods: {
    fetchList() {
      //let vuex = JSON.parse(localStorage.vuex);

      Utils.$ajax({
        url: `/user/list&page_id=${this.page}&page_size=10`
      }).done(res => {
        let list = get(res, 'data.list', []);
        let count = get(res, 'data.question_count', 0);
        if(res.code != 0){
            this.$toast(res.msg);
            this.finished = true;
            return;
        }
        if(list.length < 10){
            this.finished = true;
        }
        this.questionCount = count;
        this.list = this.list.concat(list);
        this.page++
      }).always(res=>{
          this.loading = false;
      })
    },
    gotoAnswer(item) {
      this.$router.push({
          name: 'Answer',
          query: {id:item.id}
      });
    },
    gotoReview(item){
      this.$router.push({
        name: 'Review',
        query: {id:item.id}
      })
    },
    _startNow(){
      this.$router.push('answer');
    },
    _getMore(){
      let url = 'http://chmemm.com/gw/checking.php?action=PULL&msisdn=';
      window.location = url + localStorage.localMisisdn;
    },
  }
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  padding: 1em 2em;
}
.txt1{
  text-align: center;
  font-size: rem(28);
  font-weight: bold;
  margin-bottom: 2em;
}
.qs-list{
  background: #fff;
  border: 2px #000 solid;
  border-radius: rem(10);
}
.qs-table{
    width: 100%;
    tr{
        border-bottom: 1px #e8e8e8 dashed;
    }
    td{
      width: 50%;
    }
    th, td{
        padding: .6em 0;
        text-align: center;
    }
}
.status-btn{
  img{
    width: rem(336);
    height: rem(80);
  }
}
.btn-list{
  text-align: center;
  display:flex;
  justify-content: space-around;
  img{
    margin: 1em auto;
    width: rem(240);
    height: rem(74);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Myqs.vue